var map = {
	"./Administration.ts": "33dc",
	"./Designing.ts": "1da8",
	"./Estimates.ts": "0dc9",
	"./Home.ts": "1a28",
	"./Offer.ts": "f689",
	"./Prescription.ts": "01eb",
	"./Price.ts": "a460",
	"./Services.ts": "ccc7",
	"./index.ts": "afbc",
	"./moduls/projectManagement/charts.ts": "2b95",
	"./moduls/projectManagement/document.ts": "ba27",
	"./moduls/projectManagement/download.ts": "a9d1",
	"./moduls/projectManagement/index.ts": "79ac",
	"./moduls/projectManagement/projects.ts": "c95b",
	"./moduls/projectManagement/reports.ts": "0c56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd71";